// Where the employee works decides which policies answer them. It comes from their HR record;
// they can change it (the record can be wrong), and when it's unknown they're asked.

import type { Audience, LocationSummary } from "./client.js";

export const LOCATION_LABELS: Record<Audience, string> = {
  "us-ca": "California",
  "us-other": "Another US state",
  canada: "Canada",
};
const CHOICES = Object.entries(LOCATION_LABELS) as [Audience, string][];

export function LocationPicker({ location, onChoose }: { location: LocationSummary; onChoose: (a: Audience | null) => void }) {
  const value = location.source === "chosen" ? (location.audience ?? "hr") : "hr";
  return (
    <label className="location">
      Policies for{" "}
      <select value={value} onChange={(e) => onChoose(e.target.value === "hr" ? null : (e.target.value as Audience))}>
        <option value="hr">{location.hr ? `My HR record (${LOCATION_LABELS[location.hr]})` : "Not set"}</option>
        {CHOICES.map(([v, l]) => (
          <option key={v} value={v}>
            {l}
          </option>
        ))}
      </select>
    </label>
  );
}

export function LocationAsk({ onChoose }: { onChoose: (a: Audience) => void }) {
  return (
    <div className="location-ask" role="group" aria-labelledby="where-h">
      <p id="where-h">
        <strong>Where do you work?</strong> Some policies differ by location, so this decides which ones answer you.
      </p>
      <div className="actions start">
        {CHOICES.map(([v, l]) => (
          <button key={v} type="button" onClick={() => onChoose(v)}>
            {l}
          </button>
        ))}
      </div>
    </div>
  );
}
